import { APP_BASE_PATH } from 'builder/modules/constants'
import { ResumeEditorQueryParams } from 'builder/modules/panel'

export function getTailoringResumeEditorLink(resumeId: number): string {
  return `${APP_BASE_PATH}/resumes/${resumeId}/edit?${ResumeEditorQueryParams.isResumeTailor}=true`
}
